angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/password/recover.html',
    '<!-- Logo -->\n' +
    '<header class="logo-bar">\n' +
    '    <div class="container-fluid">\n' +
    '        <a href="" ui-sref="index" class="logo">\n' +
    '            <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                <polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53" />\n' +
    '                <polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7" />\n' +
    '                <polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3" />\n' +
    '            </svg>\n' +
    '            <div>\n' +
    '                <strong>pe</strong><span>4</span>h</div>\n' +
    '        </a>\n' +
    '    </div>\n' +
    '</header>\n' +
    '<section class="content access">\n' +
    '    <div class="container-fluid gradient-blu">\n' +
    '        <!-- Recover password -->\n' +
    '        <form id="recoverPasswordForm" name="recoverPasswordForm" ng-submit="recoverPassword()" novalidate="">\n' +
    '            <div id="recover">\n' +
    '                <h2 class="sliding">Reset password</h2>\n' +
    '                <div class="box">\n' +
    '                    <div class="form-group sliding">\n' +
    '                        <input ng-model="newPassword" name="password1" type="password" id="Password1" required min-length="6">\n' +
    '                        <label for="Password1">New password</label>\n' +
    '                        <footer></footer>\n' +
    '                    </div>\n' +
    '                    <div class="form-group sliding">\n' +
    '                        <input ng-model="newPasswordConfirmation" name="password2" type="password" id="Password2" required min-length="6" compare-to="Password1">\n' +
    '                        <label for="Password2">Confirm password</label>\n' +
    '                        <footer></footer>\n' +
    '                    </div>\n' +
    '                    <div class="form-group sliding">\n' +
    '                        <button ng-disabled="recoverPasswordForm.$invalid" class="btn btn-primary btn-lg btn-block" type="submit">Change password</button>\n' +
    '                    </div>\n' +
    '                    <div class="text-right sliding">\n' +
    '                        <a class="passwd" ui-sref="login">Return to Log in</a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '    </div>\n' +
    '</section>');
}]);
